import StatusItem, {typesOfData} from "./StatusItem";

export class StatusItemChecks extends StatusItem {
    constructor(dataObject) {
        super(dataObject)
        this.itemType = typesOfData.checks
    }

    get hasNotes() {
        return this.numberOfNotes === 0
    }

    get indicatorCurrent() {
        return this.statusCode
    }

    get statusCode() {
        return this.hasNotes ? 3 : 2;
    }

    get result() {
        return this.hasNotes ? 'Inga anmärkningar' : 'Anmärkning finns';
    }
}